import PlanData from '../Data/PlanData'

export const getImageLimitStatus = (userRole, choices) => {
  const finalUserRole = userRole === 'none' ? 'subscriber' : userRole
  const userPlan = PlanData.find(plan => plan.plan === finalUserRole)
  const limit = userPlan.numberOfImage
  const imageCount = choices.filter(i => i.data).length

  return `${imageCount}/${limit}`
}

export const validateImageLimit = (userRole, choices, choiceHDImages) => {
  const userPlan = PlanData.find(plan => plan.plan === userRole)
  const limit = userPlan.numberOfImage
  const imageCount = choices.filter(i => i.data).length
  const imageHDCount = choiceHDImages.filter(i => i.index !== -1).length

  if (userRole === 'subscriber' && imageHDCount > 0) {
    return `Free plan supports standard images only. Please subscribe to a Premium plan to support HD images.`
  }

  if (imageCount > limit) {
    return `Unable to save file due to excess the limit of image uploaded. Total images: ${imageCount}/${limit}.`
  }

  return null
}

export const validateShareImageLimit = (
  shareMethod,
  userRole,
  choices,
  choiceHDImages,
) => {
  const finalUserRole =
    shareMethod === 'Guest'
      ? 'subscriber'
      : userRole === 'none'
      ? 'subscriber'
      : userRole
  const limit = PlanData.find(plan => plan.plan === finalUserRole).numberOfImage
  const imageHDCount = choiceHDImages.filter(i => i.index !== -1).length
  const imageCount = choices.filter(i => i.data).length

  if (imageHDCount > 0) {
    if (shareMethod === 'Guest') {
      return `Unable to share HD image. Guest sharing only supports standard images. You can share HD images by using Share from File instead.`
    } else if (userRole === 'subscriber') {
      return `Free plan supports standard images only. Please subscribe to a Premium plan to share HD images.`
    }
  }

  if (imageCount > limit) {
    if (shareMethod === 'Guest') {
      return `Unable to share due to excess the limit of image for guest sharing. Total images: ${imageCount}/${limit}. You can share more images by using Share from File instead.`
    } else {
      return `Unable to share due to excess the limit of image uploaded. Total images: ${imageCount}/${limit}.`
    }
  }

  return null
}
